import AssetTableParamsProvider from '@e2grnd/ui-core/dist/contexts/AssetTableParamsProvider'
import { NumericOperation } from '@e2grnd/ui-core/dist/gql/graphql'
import type { PropsWithChildren } from 'react'
import * as boar from '../calculators/boar/asset-table-config'
// Import only lightweight asset-table configs (params + examples + mapFn).
// This avoids pulling full calculator modules (steps, graphs, report, dataTables)
// into the main entry chunk — saving ~4 MB from initial page load.
import * as burstPressure from '../calculators/burstPressure/asset-table-config'
import * as cuiSight from '../calculators/cuiSight/asset-table-config'
import * as damageSight from '../calculators/damageSight/asset-table-config'
import * as vanWinkle from '../calculators/vanWinkle/asset-table-config'

export default function AssetTableParamsProviderWrapper(props: PropsWithChildren) {
  return (
    <AssetTableParamsProvider
      value={{
        vanWinkle: {
          params: vanWinkle.params,
          examples: vanWinkle.examples,
          assetParamsMapFn: vanWinkle.assetParamsMapFn,
          resultParams: [{ paramName: 'sleptFor', operation: NumericOperation.Avg }],
        },
        burstPressure: {
          params: burstPressure.params,
          examples: burstPressure.examples,
          assetComponentParamsMapFn: burstPressure.assetComponentParamsMapFn,
          resultParams: [{ paramName: 'BURSTP>PBURSTE', operation: NumericOperation.Max }],
        },
        damageSight: {
          params: damageSight.params,
          examples: damageSight.examples,
          assetComponentParamsMapFn: damageSight.assetComponentParamsMapFn,
          resultParams: [
            { paramName: 'corrosionRateEV', operation: NumericOperation.Max },
            { paramName: 'failureTimeEV', operation: NumericOperation.Min },
            { paramName: 'failureProbYes', operation: NumericOperation.Max },
            { paramName: 'risk', operation: NumericOperation.Max },
          ],
        },
        cuiSight: {
          params: cuiSight.params,
          examples: cuiSight.examples,
          assetComponentParamsMapFn: cuiSight.assetComponentParamsMapFn,
          resultParams: [
            { paramName: 'corrosionAllowanceEV', operation: NumericOperation.Min },
            { paramName: 'operatingTemperatureMean', operation: NumericOperation.Min },
            { paramName: 'coatingFailureTimeEV', operation: NumericOperation.Min },
            { paramName: 'jacketingFailureTimeEV', operation: NumericOperation.Min },
            { paramName: 'initiationTimeEV', operation: NumericOperation.Min },
            { paramName: 'wetCorrosionRateEV', operation: NumericOperation.Max },
            { paramName: 'internalExposureFractionEV', operation: NumericOperation.Max },
            { paramName: 'damageRateEV', operation: NumericOperation.Max },
            { paramName: 'compFailureTimeEVAtTargetMinPOF', operation: NumericOperation.Min },
            { paramName: 'failureTimeEV', operation: NumericOperation.Min },
            { paramName: 'remainingLifeEV', operation: NumericOperation.Min },
            { paramName: 'pofAfter', operation: NumericOperation.Max },
          ],
        },
        boar: {
          params: boar.params,
          examples: boar.examples,
          assetParamsMapFn: boar.assetParamsMapFn,
          resultParams: [{ paramName: 'circCrB50', operation: NumericOperation.Max }],
        },
      }}
    >
      {props.children}
    </AssetTableParamsProvider>
  )
}
